import { useContext, useMemo } from 'react';
import { Box, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import classes from '../filters/Filters.module.scss';
import { FilterNames } from '../../enums/FilterNames';
import { resetFilters } from '../../../store/filters/filters.slice';
import Filter from '../../components/filter/Filter';
import StringHelper from '../../helpers/string.helper';
import DetectMobileHelper from '../../helpers/detect-mobile.helper';
import TagsDropdown from '../../components/tags-dropdown/TagsDropdown';
import SaveFilters from '../../components/filter/save-filters/SaveFilters';
import PreferenceContext from '../../context/PreferenceContext';
import TipsterDropdown from '../../components/tipster-dropdown/TipsterDropdown';
import { RootState } from '../../../store';
import { Content } from '../../enums/Content';

const Filters = () => {
  const filters = useSelector(
    (state: RootState) => state.filters.filters
  );
  const { setPreferenceID } = useContext(PreferenceContext);
  const dispatch = useDispatch();

  const renderButtons = useMemo(() => {
    const handleClearFilters = (event: React.MouseEvent<HTMLButtonElement>) => {
      setPreferenceID(0);
      dispatch(resetFilters());
    };

    const isSaveButtonVisible = Object.entries(filters).some(([key, value]) => {
      if (key === 'date' || key === 'hasWords' || key === 'author') {
        return false;
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return value !== null;
    });

    const isClearButtonVisible = Object.entries(filters).some(([key, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return value !== null;
    });

    return <>
      <SaveFilters filters={filters} hidden={!isSaveButtonVisible} />
      <Button
        className={classes.button}
        onClick={handleClearFilters}
        hidden={!isClearButtonVisible}
      >
        Clear All
      </Button>
    </>
  }, [dispatch, filters, setPreferenceID])

  const renderFilters = useMemo(() => {
    if (DetectMobileHelper.isMobile()) {
      return <Box className='d-flex flex-column h-75 p-4 align-items-center justify-content-between'>
          <Box className='h-50 d-flex flex-column justify-content-between'>
          <Filter key={StringHelper.generateRandomString(10)} name={FilterNames.TYPE} />
          <TipsterDropdown />
          <Filter key={StringHelper.generateRandomString(10)} name={FilterNames.SITE} />
          <TagsDropdown content={Content.ARTICLES}/>
          </Box>
          <Box className='d-flex flex-row justify-content-between'>
            {renderButtons}
          </Box>
      </Box>
    }

    return (
      <Box className='d-flex flex-row justify-content-between flex-wrap gap-2'>
        <Filter key={StringHelper.generateRandomString(10)} name={FilterNames.TYPE} />
        <TipsterDropdown />
        <Filter key={StringHelper.generateRandomString(10)} name={FilterNames.SITE} />
        <TagsDropdown content={Content.ARTICLES}/>
        {renderButtons}
      </Box>
    );
  }, [renderButtons]);

  return <>
    {renderFilters}
  </>
};

export default Filters;
